import {Component, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MatPaginator } from "@angular/material/paginator";
import {MatSort } from "@angular/material/sort";
import {Grabaciones } from '../intefaces/grabaciones.interface';
import {CoursesService} from "../services/courses.service";
import {Lesson} from '../model/lesson';
import {SelectionModel} from '@angular/cdk/collections';
import {HttpClient, HttpHeaders} from "@angular/common/http";


@Component({
    selector: 'grabacion',
    templateUrl: './grabacion.component.html',
    styleUrls: ['./grabacion.component.scss']
})
export class GrabacionComponent   {


    private httpOptions = {
        headers: new HttpHeaders({
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "Content-Type",
          "Access-Control-Allow-Methods": "GET, OPTIONS, POST",
          "Content-Type": "application/json"
        })
      };

    grabacion:Grabaciones;
    lessons: Lesson[] = [];
    loading = false;
    private collecctionToAdd = {};

    @ViewChild(MatPaginator)
    paginator: MatPaginator;

    @ViewChild(MatSort)
    sort: MatSort;
    selection = new SelectionModel<Lesson>(true, []);

    constructor(private route: ActivatedRoute,
                private coursesService: CoursesService,private http: HttpClient) {

    }
    displayedColumns = ['select', 'seqNo', "description", "duration"];
    expandedLesson: Lesson = null;
}
















